import _ from 'lodash';
import { push } from 'react-router-redux';
import * as types from './action-types';
import { BankIdService } from 'frilans-finans';
import { authenticationService } from 'interactive-solutions/authentication';

export function setSocialSecurityNr (socialSecurityNr) {
  return {
    type: types.SET_SOCIAL_SECURITY_NR,
    payload: socialSecurityNr
  };
}

export function setEmail (email) {
  return {
    type: types.SET_EMAIL,
    payload: email
  };
}

export function setInProgress (bool) {
  return {
    type: types.SET_IN_PROGRESS,
    payload: bool
  };
}

export function setLoginSucceeded (bool) {
  return {
    type: types.SET_LOGIN_SUCCEEDED,
    payload: bool
  };
}

export function setError (error) {
  return {
    type: types.SET_ERROR,
    payload: error
  };
}

export function setAuthType (authType) {
  return {
    type: types.SET_AUTH_TYPE,
    payload: authType
  };
}

export function setEntity (data) {
  return {
    type: types.SET_ENTITY,
    payload: data
  };
}

export function setCreateOnAuth (bool) {
  return {
    type: types.SET_CREATE_ON_AUTH,
    payload: bool
  };
}

// Thunks

const TIMEOUT = 60;
const DELAY = 500;

let pendingRequest,
  timer,
  startedAt;

export function startTimer () {
  return (dispatch) => {
    startedAt = new Date();
    timer = setInterval(
      () => dispatch(checkTimeout()),
      DELAY
    );
  };
}

export function checkTimeout () {
  return (dispatch) => {
    let done = ((new Date()) - startedAt)/1000 > TIMEOUT;

    if (done) {
      dispatch(cancel());
    }
  };
}

export function requestLogin () {
  return (dispatch, getState) => {
    const { bankId } = getState();
    const ssnr = bankId.authType === 'MOBILE' ? bankId.socialSecurityNr : '';
    const email = bankId.authType === 'MOBILE' ? bankId.email : '';
    pendingRequest = BankIdService.requestLogin(ssnr, email);
    dispatch(setInProgress(true));
    dispatch(startTimer());
    pendingRequest.promise.then((entity) => {
      if (entity) {
        dispatch(setEntity(entity));
        dispatch(startComputerApp(entity));
        dispatch(tryToLogin());
      }
    })
    .catch((error) => {
      error = BankIdService.getErrors(error);
      dispatch(setError(error));
      dispatch(cancel());
    });
  };
}

export function tryToLogin (sessionId) {
  return (dispatch, getState) => {
    const { bankId } = getState();

    if (!bankId.inProgress) {
      dispatch(setError({key: 'CANCELLED'}));
      return;
    }

    pendingRequest = authenticationService.loginWithBankId(bankId.entity.sessionId, bankId.createOnAuth);

    pendingRequest.promise.then((entity) => {
      dispatch(setInProgress(false));
      dispatch(setLoginSucceeded(true));
      dispatch(push('/activities'));
    })
    .catch((error) => {
      if (error && error.status) {
        switch (error.status) {
          case 412:
            _.delay(() => {
              dispatch(tryToLogin());
            }, DELAY);
            break;
          case 404:
            dispatch(setInProgress(false));
            dispatch(setError({key: 'BANKID_USER_NOT_FOUND', keep: true}));
            dispatch(push('/register?tab=' + bankId.authType));
            break;
          case 403:
            dispatch(setError({key: 'BANKID_LOGIN_FAILED', keep: false}));
            dispatch(cancel());
            break;
          case 400:
            dispatch(setError({key: 'CANCELLED', keep: true}));
            dispatch(cancel());
            break;
          default:
            dispatch(setError(error));
            dispatch(cancel());
            break;
        }
      } else {
        dispatch(setError({key: 'GENERAL_ERROR'}));
        dispatch(cancel());
      }
    });
  };
}

export function cancel () {
  return (dispatch) => {
    clearTimeout(timer);
    dispatch(setInProgress(false));

    if (pendingRequest && pendingRequest.cancel) {
      pendingRequest.cancel('CANCELLED');
    }
  };
}

export function clearError (force = false) {
  return (dispatch, getState) => {
    const { bankId } = getState();

    if (force || (bankId.error !== null && !bankId.error.keep)) {
      dispatch(setError(null));
    }
  };
}

// Open BankID app on computers
export function startComputerApp (entity) {
  return (dispatch) => {
    if (entity.autostart) {
      document.location.href = entity.autostart;
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-id/index.js
 **/